module.exports = __webpack_public_path__ + "static/media/olake-benchmark-1.ca1ac0ea.svg";